<template>
  <div v-if="item">
    <fields-list :item="item" :fields="fields" />
    <variants :id="id"></variants>
    <conditionals :id="id"></conditionals>
    <div class="save-group">
      <button class="btn btn-warning btn-icon" @click="updateItem">
        <span class="ti-save"></span>{{ "save" | setText("Сохранить") }}
      </button>
    </div>
  </div>
</template>

<script>
import { cardUpdate, cardContent, pushLang } from "@/plugins/functions";
import Variants from "./Variants";
import Conditionals from "./Conditionals";

export default {
  components: {
    Variants,
    Conditionals,
  },
  data: () => ({
    cardLink: "promotions",
    cardSetLink: "promotions",
    item: null,
    fields: [
      {
        col: " col-12 col-md-12",
        key: "is_active",
        labelKey: "is_active",
        label: "Активность",
        type: "checkbox",
      },
      {
        col: " col-12 col-md-12",
        key: "is_export_price",
        labelKey: "is_export_price",
        label: "Экспортируемая скидка основной цены",
        type: "checkbox",
      },
      {
        col: " col-12 col-md-6",
        key: "name",
        labelKey: "name",
        label: "Название",
        type: "field",
        textType: "text",
      },
      {
        col: " col-12 col-md-6",
        key: "discount",
        labelKey: "discount",
        label: "Скидка",
        type: "field",
        textType: "text",
      },
      {
        col: "col-12",
        key: "shops",
        modal: "shop",
        selectKey: "name",
        type: "selects",
      },
    ],
  }),

  props: ["id"],
  async created() {
    // this.pushLang();
    this.item = await this.cardContent(this.cardLink, this.id);
  },
  methods: {
    cardUpdate: cardUpdate,
    cardContent: cardContent,
    pushLang: pushLang,
    async updateItem() {
      let item = await this.cardUpdate(
        this.cardSetLink,
        this.item,
        this.fields
      );
      // if (item){
      //   this.item = item;
      // }
    },
  },
};
</script>
<style>
</style>
